import React, { useEffect, useMemo } from "react";

import ModalBase from "./ModalBase";

interface EnvVarsModalProps {
  /** Provided by ModalGlobal — closes the modal. */
  onClose: (result?: any) => void;
}

// Front-end env snapshot for debugging — shown here and echoed to the console like the old inline panel did
const EnvVarsModal: React.FC<EnvVarsModalProps> = ({ onClose }) => {
  const envVars = useMemo(
    () =>
      Object.keys(process.env).reduce(
        (acc, key) => ({ ...acc, [key]: process.env[key] ?? "" }),
        {} as Record<string, string>
      ),
    []
  );

  useEffect(() => {
    console.log("Front-end environment variables:", envVars);
  }, [envVars]);

  return (
    <ModalBase title="Environment Variables" onClose={() => onClose()} size="md">
      <p className="mb-3 font-inter text-eai-body-sm text-eai-ink-muted">
        Front-end environment variables, also logged to the console.
      </p>
      <pre className="max-h-96 overflow-y-auto whitespace-pre-wrap break-all rounded-md border border-eai-border bg-eai-surface-hover p-4 font-mono text-xs text-eai-ink-muted">
        {JSON.stringify(envVars, null, 2)}
      </pre>
    </ModalBase>
  );
};

export default EnvVarsModal;
